import { Components } from '@mui/material'

export function OverridedFab(): Components {
  return {
    MuiFab: {
      styleOverrides: {
        root: {
          zIndex: 1,
        },
      },
    },
  }
}
